import { render, staticRenderFns } from "./DepartmentStatistics.vue?vue&type=template&id=132b10c3&scoped=true"
import script from "./DepartmentStatistics.vue?vue&type=script&lang=js"
export * from "./DepartmentStatistics.vue?vue&type=script&lang=js"
import style0 from "./DepartmentStatistics.vue?vue&type=style&index=0&id=132b10c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b10c3",
  null
  
)

export default component.exports